import { render, staticRenderFns } from "./ProjectWorkers.vue?vue&type=template&id=56903d7f&"
import script from "./ProjectWorkers.vue?vue&type=script&lang=js&"
export * from "./ProjectWorkers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports